import { render } from "./AgentLeadCard.vue?vue&type=template&id=5687ae05&scoped=true"
import script from "./AgentLeadCard.vue?vue&type=script&lang=js"
export * from "./AgentLeadCard.vue?vue&type=script&lang=js"

import "./AgentLeadCard.vue?vue&type=style&index=0&id=5687ae05&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5687ae05"]])

export default __exports__